import { createFileRoute, redirect } from '@tanstack/react-router';

// Link antigo do legado (`/cadastro/fundos/:fundId/cessoes`): a aba agora vive em `?tab=` (U42).
export const Route = createFileRoute('/_app/cadastro/fundos/$fundId/cessoes')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() é o contrato do TanStack Router.
    throw redirect({ to: '/cadastro/fundos/$fundId', params: { fundId: params.fundId }, search: { tab: 'cessoes' } });
  },
});
